<app-relatorio-veiculo-detalhado-filtro [filtros]="filtros"></app-relatorio-veiculo-detalhado-filtro>
<app-barra-consulta-mensal *ngIf="!carregando" visible="false" [listagemComFiltros]="getListagemComFiltros()"
  (atualizando)="atualizar($event)" (inserindo)="novo($event)" (definirFiltro)="definirFiltragem()" [exibirNovo]="false"
  (voltando)="voltar()">
</app-barra-consulta-mensal>
<div class="conteudo">
  <app-loading [exibir]="carregando"></app-loading>
  <div *ngIf="!carregando">
    <div class="row">

    </div>
    <div class="content">
      <button class="btn btn-outline-secondary btn-sm mb-2 float-right" (click)="exportarExcel()">
        <em class="fa fa-download fa-xs"></em>
        Export Excel
      </button>
    </div>
    <table class="table table-hover table-striped table-bordered" id="excel-table">
      <thead class="thead-dark; border-color: #32383e;">
        <tr style="color: #fff; background-color: #212529; border-color: #32383e;">
          <th></th>
          <th class="text-right">
            Jan
          </th>
          <th class="text-right">
            Fev
          </th>
          <th class="text-right">
            Mar
          </th>
          <th class="text-right">
            Abr
          </th>
          <th class="text-right">
            Mai
          </th>
          <th class="text-right">
            Jun
          </th>
          <th class="text-right">
            Jul
          </th>
          <th class="text-right">
            Ago
          </th>
          <th class="text-right">
            Set
          </th>
          <th class="text-right">
            Out
          </th>
          <th class="text-right">
            Nov
          </th>
          <th class="text-right">
            Dez
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{dadosMensal.objetivo_venda.descricao}}</td>
          <td class="text-right">{{dadosMensal.objetivo_venda.mes_01}}</td>
          <td class="text-right">{{dadosMensal.objetivo_venda.mes_02}}</td>
          <td class="text-right">{{dadosMensal.objetivo_venda.mes_03}}</td>
          <td class="text-right">{{dadosMensal.objetivo_venda.mes_04}}</td>
          <td class="text-right">{{dadosMensal.objetivo_venda.mes_05}}</td>
          <td class="text-right">{{dadosMensal.objetivo_venda.mes_06}}</td>
          <td class="text-right">{{dadosMensal.objetivo_venda.mes_07}}</td>
          <td class="text-right">{{dadosMensal.objetivo_venda.mes_08}}</td>
          <td class="text-right">{{dadosMensal.objetivo_venda.mes_09}}</td>
          <td class="text-right">{{dadosMensal.objetivo_venda.mes_10}}</td>
          <td class="text-right">{{dadosMensal.objetivo_venda.mes_11}}</td>
          <td class="text-right">{{dadosMensal.objetivo_venda.mes_12}}</td>
        </tr>
        <tr *ngFor="let dados of dadosMensal.vend_nao_faturado_varejo.linhas">
          <td>{{dados.descricao}}</td>
          <td class="text-right">{{dados.mes_01}}</td>
          <td class="text-right">{{dados.mes_02}}</td>
          <td class="text-right">{{dados.mes_03}}</td>
          <td class="text-right">{{dados.mes_04}}</td>
          <td class="text-right">{{dados.mes_05}}</td>
          <td class="text-right">{{dados.mes_06}}</td>
          <td class="text-right">{{dados.mes_07}}</td>
          <td class="text-right">{{dados.mes_08}}</td>
          <td class="text-right">{{dados.mes_09}}</td>
          <td class="text-right">{{dados.mes_10}}</td>
          <td class="text-right">{{dados.mes_11}}</td>
          <td class="text-right">{{dados.mes_12}}</td>
        </tr>
        <tr *ngFor="let dados of dadosMensal.vend_nao_faturado_venda.linhas">
          <td>{{dados.descricao}}</td>
          <td class="text-right">{{dados.mes_01}}</td>
          <td class="text-right">{{dados.mes_02}}</td>
          <td class="text-right">{{dados.mes_03}}</td>
          <td class="text-right">{{dados.mes_04}}</td>
          <td class="text-right">{{dados.mes_05}}</td>
          <td class="text-right">{{dados.mes_06}}</td>
          <td class="text-right">{{dados.mes_07}}</td>
          <td class="text-right">{{dados.mes_08}}</td>
          <td class="text-right">{{dados.mes_09}}</td>
          <td class="text-right">{{dados.mes_10}}</td>
          <td class="text-right">{{dados.mes_11}}</td>
          <td class="text-right">{{dados.mes_12}}</td>
        </tr>
        <tr *ngFor="let dados of dadosMensal.qtd_carros_estoque.linhas">
          <td>{{dados.descricao}}</td>
          <td class="text-right">{{dados.mes_01}}</td>
          <td class="text-right">{{dados.mes_02}}</td>
          <td class="text-right">{{dados.mes_03}}</td>
          <td class="text-right">{{dados.mes_04}}</td>
          <td class="text-right">{{dados.mes_05}}</td>
          <td class="text-right">{{dados.mes_06}}</td>
          <td class="text-right">{{dados.mes_07}}</td>
          <td class="text-right">{{dados.mes_08}}</td>
          <td class="text-right">{{dados.mes_09}}</td>
          <td class="text-right">{{dados.mes_10}}</td>
          <td class="text-right">{{dados.mes_11}}</td>
          <td class="text-right">{{dados.mes_12}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.total_vnf.descricao}}</td>
          <td class="text-right">{{dadosMensal.total_vnf.mes_01}}</td>
          <td class="text-right">{{dadosMensal.total_vnf.mes_02}}</td>
          <td class="text-right">{{dadosMensal.total_vnf.mes_03}}</td>
          <td class="text-right">{{dadosMensal.total_vnf.mes_04}}</td>
          <td class="text-right">{{dadosMensal.total_vnf.mes_05}}</td>
          <td class="text-right">{{dadosMensal.total_vnf.mes_06}}</td>
          <td class="text-right">{{dadosMensal.total_vnf.mes_07}}</td>
          <td class="text-right">{{dadosMensal.total_vnf.mes_08}}</td>
          <td class="text-right">{{dadosMensal.total_vnf.mes_09}}</td>
          <td class="text-right">{{dadosMensal.total_vnf.mes_10}}</td>
          <td class="text-right">{{dadosMensal.total_vnf.mes_11}}</td>
          <td class="text-right">{{dadosMensal.total_vnf.mes_12}}</td>
        </tr>
        <tr *ngFor="let dados of dadosMensal.faturado_varejo.linhas">
          <td>{{dados.descricao}}</td>
          <td class="text-right">{{dados.mes_01}}</td>
          <td class="text-right">{{dados.mes_02}}</td>
          <td class="text-right">{{dados.mes_03}}</td>
          <td class="text-right">{{dados.mes_04}}</td>
          <td class="text-right">{{dados.mes_05}}</td>
          <td class="text-right">{{dados.mes_06}}</td>
          <td class="text-right">{{dados.mes_07}}</td>
          <td class="text-right">{{dados.mes_08}}</td>
          <td class="text-right">{{dados.mes_09}}</td>
          <td class="text-right">{{dados.mes_10}}</td>
          <td class="text-right">{{dados.mes_11}}</td>
          <td class="text-right">{{dados.mes_12}}</td>
        </tr>
        <tr *ngFor="let dados of dadosMensal.faturado_venda.linhas">
          <td>{{dados.descricao}}</td>
          <td class="text-right">{{dados.mes_01}}</td>
          <td class="text-right">{{dados.mes_02}}</td>
          <td class="text-right">{{dados.mes_03}}</td>
          <td class="text-right">{{dados.mes_04}}</td>
          <td class="text-right">{{dados.mes_05}}</td>
          <td class="text-right">{{dados.mes_06}}</td>
          <td class="text-right">{{dados.mes_07}}</td>
          <td class="text-right">{{dados.mes_08}}</td>
          <td class="text-right">{{dados.mes_09}}</td>
          <td class="text-right">{{dados.mes_10}}</td>
          <td class="text-right">{{dados.mes_11}}</td>
          <td class="text-right">{{dados.mes_12}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.total_faturado.descricao}}</td>
          <td class="text-right">{{dadosMensal.total_faturado.mes_01}}</td>
          <td class="text-right">{{dadosMensal.total_faturado.mes_02}}</td>
          <td class="text-right">{{dadosMensal.total_faturado.mes_03}}</td>
          <td class="text-right">{{dadosMensal.total_faturado.mes_04}}</td>
          <td class="text-right">{{dadosMensal.total_faturado.mes_05}}</td>
          <td class="text-right">{{dadosMensal.total_faturado.mes_06}}</td>
          <td class="text-right">{{dadosMensal.total_faturado.mes_07}}</td>
          <td class="text-right">{{dadosMensal.total_faturado.mes_08}}</td>
          <td class="text-right">{{dadosMensal.total_faturado.mes_09}}</td>
          <td class="text-right">{{dadosMensal.total_faturado.mes_10}}</td>
          <td class="text-right">{{dadosMensal.total_faturado.mes_11}}</td>
          <td class="text-right">{{dadosMensal.total_faturado.mes_12}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.total_varejo.descricao}}</td>
          <td class="text-right">{{dadosMensal.total_varejo.mes_01}}</td>
          <td class="text-right">{{dadosMensal.total_varejo.mes_02}}</td>
          <td class="text-right">{{dadosMensal.total_varejo.mes_03}}</td>
          <td class="text-right">{{dadosMensal.total_varejo.mes_04}}</td>
          <td class="text-right">{{dadosMensal.total_varejo.mes_05}}</td>
          <td class="text-right">{{dadosMensal.total_varejo.mes_06}}</td>
          <td class="text-right">{{dadosMensal.total_varejo.mes_07}}</td>
          <td class="text-right">{{dadosMensal.total_varejo.mes_08}}</td>
          <td class="text-right">{{dadosMensal.total_varejo.mes_09}}</td>
          <td class="text-right">{{dadosMensal.total_varejo.mes_10}}</td>
          <td class="text-right">{{dadosMensal.total_varejo.mes_11}}</td>
          <td class="text-right">{{dadosMensal.total_varejo.mes_12}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.total_venda_direta.descricao}}</td>
          <td class="text-right">{{dadosMensal.total_venda_direta.mes_01}}</td>
          <td class="text-right">{{dadosMensal.total_venda_direta.mes_02}}</td>
          <td class="text-right">{{dadosMensal.total_venda_direta.mes_03}}</td>
          <td class="text-right">{{dadosMensal.total_venda_direta.mes_04}}</td>
          <td class="text-right">{{dadosMensal.total_venda_direta.mes_05}}</td>
          <td class="text-right">{{dadosMensal.total_venda_direta.mes_06}}</td>
          <td class="text-right">{{dadosMensal.total_venda_direta.mes_07}}</td>
          <td class="text-right">{{dadosMensal.total_venda_direta.mes_08}}</td>
          <td class="text-right">{{dadosMensal.total_venda_direta.mes_09}}</td>
          <td class="text-right">{{dadosMensal.total_venda_direta.mes_10}}</td>
          <td class="text-right">{{dadosMensal.total_venda_direta.mes_11}}</td>
          <td class="text-right">{{dadosMensal.total_venda_direta.mes_12}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.total_vnf_faturado.descricao}}</td>
          <td class="text-right">{{dadosMensal.total_vnf_faturado.mes_01}}</td>
          <td class="text-right">{{dadosMensal.total_vnf_faturado.mes_02}}</td>
          <td class="text-right">{{dadosMensal.total_vnf_faturado.mes_03}}</td>
          <td class="text-right">{{dadosMensal.total_vnf_faturado.mes_04}}</td>
          <td class="text-right">{{dadosMensal.total_vnf_faturado.mes_05}}</td>
          <td class="text-right">{{dadosMensal.total_vnf_faturado.mes_06}}</td>
          <td class="text-right">{{dadosMensal.total_vnf_faturado.mes_07}}</td>
          <td class="text-right">{{dadosMensal.total_vnf_faturado.mes_08}}</td>
          <td class="text-right">{{dadosMensal.total_vnf_faturado.mes_09}}</td>
          <td class="text-right">{{dadosMensal.total_vnf_faturado.mes_10}}</td>
          <td class="text-right">{{dadosMensal.total_vnf_faturado.mes_11}}</td>
          <td class="text-right">{{dadosMensal.total_vnf_faturado.mes_12}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.percentual_objetivo_venda.descricao}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_objetivo_venda.mes_01 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_objetivo_venda.mes_02 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_objetivo_venda.mes_03 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_objetivo_venda.mes_04 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_objetivo_venda.mes_05 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_objetivo_venda.mes_06 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_objetivo_venda.mes_07 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_objetivo_venda.mes_08 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_objetivo_venda.mes_09 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_objetivo_venda.mes_10 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_objetivo_venda.mes_11 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_objetivo_venda.mes_12 | percent: '1.0-0'}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.fluxo_showroom.descricao}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom.mes_01}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom.mes_02}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom.mes_03}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom.mes_04}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom.mes_05}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom.mes_06}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom.mes_07}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom.mes_08}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom.mes_09}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom.mes_10}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom.mes_11}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom.mes_12}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.percentual_venda_sr.descricao}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_sr.mes_01 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_sr.mes_02 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_sr.mes_03 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_sr.mes_04 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_sr.mes_05 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_sr.mes_06 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_sr.mes_07 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_sr.mes_08 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_sr.mes_09 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_sr.mes_10 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_sr.mes_11 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_sr.mes_12 | percent: '1.0-0'}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.fluxo_showroom_oficina.descricao}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom_oficina.mes_01}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom_oficina.mes_02}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom_oficina.mes_03}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom_oficina.mes_04}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom_oficina.mes_05}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom_oficina.mes_06}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom_oficina.mes_07}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom_oficina.mes_08}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom_oficina.mes_09}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom_oficina.mes_10}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom_oficina.mes_11}}</td>
          <td class="text-right">{{dadosMensal.fluxo_showroom_oficina.mes_12}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.percentual_venda_oficina.descricao}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_oficina.mes_01 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_oficina.mes_02 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_oficina.mes_03 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_oficina.mes_04 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_oficina.mes_05 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_oficina.mes_06 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_oficina.mes_07 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_oficina.mes_08 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_oficina.mes_09 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_oficina.mes_10 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_oficina.mes_11 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_oficina.mes_12 | percent: '1.0-0'}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.percentual_collaboration.descricao}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_collaboration.mes_01 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_collaboration.mes_02 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_collaboration.mes_03 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_collaboration.mes_04 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_collaboration.mes_05 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_collaboration.mes_06 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_collaboration.mes_07 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_collaboration.mes_08 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_collaboration.mes_09 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_collaboration.mes_10 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_collaboration.mes_11 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_collaboration.mes_12 | percent: '1.0-0'}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.quantidade_lead.descricao}}</td>
          <td class="text-right">{{dadosMensal.quantidade_lead.mes_01}}</td>
          <td class="text-right">{{dadosMensal.quantidade_lead.mes_02}}</td>
          <td class="text-right">{{dadosMensal.quantidade_lead.mes_03}}</td>
          <td class="text-right">{{dadosMensal.quantidade_lead.mes_04}}</td>
          <td class="text-right">{{dadosMensal.quantidade_lead.mes_05}}</td>
          <td class="text-right">{{dadosMensal.quantidade_lead.mes_06}}</td>
          <td class="text-right">{{dadosMensal.quantidade_lead.mes_07}}</td>
          <td class="text-right">{{dadosMensal.quantidade_lead.mes_08}}</td>
          <td class="text-right">{{dadosMensal.quantidade_lead.mes_09}}</td>
          <td class="text-right">{{dadosMensal.quantidade_lead.mes_10}}</td>
          <td class="text-right">{{dadosMensal.quantidade_lead.mes_11}}</td>
          <td class="text-right">{{dadosMensal.quantidade_lead.mes_12}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.venda_originada_lead.descricao}}</td>
          <td class="text-right">{{dadosMensal.venda_originada_lead.mes_01}}</td>
          <td class="text-right">{{dadosMensal.venda_originada_lead.mes_02}}</td>
          <td class="text-right">{{dadosMensal.venda_originada_lead.mes_03}}</td>
          <td class="text-right">{{dadosMensal.venda_originada_lead.mes_04}}</td>
          <td class="text-right">{{dadosMensal.venda_originada_lead.mes_05}}</td>
          <td class="text-right">{{dadosMensal.venda_originada_lead.mes_06}}</td>
          <td class="text-right">{{dadosMensal.venda_originada_lead.mes_07}}</td>
          <td class="text-right">{{dadosMensal.venda_originada_lead.mes_08}}</td>
          <td class="text-right">{{dadosMensal.venda_originada_lead.mes_09}}</td>
          <td class="text-right">{{dadosMensal.venda_originada_lead.mes_10}}</td>
          <td class="text-right">{{dadosMensal.venda_originada_lead.mes_11}}</td>
          <td class="text-right">{{dadosMensal.venda_originada_lead.mes_12}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.percentual_conversao_lead.descricao}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_conversao_lead.mes_01 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_conversao_lead.mes_02 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_conversao_lead.mes_03 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_conversao_lead.mes_04 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_conversao_lead.mes_05 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_conversao_lead.mes_06 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_conversao_lead.mes_07 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_conversao_lead.mes_08 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_conversao_lead.mes_09 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_conversao_lead.mes_10 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_conversao_lead.mes_11 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_conversao_lead.mes_12 | percent: '1.0-0'}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.percentual_contribuicao_lead.descricao}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_contribuicao_lead.mes_01 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_contribuicao_lead.mes_02 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_contribuicao_lead.mes_03 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_contribuicao_lead.mes_04 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_contribuicao_lead.mes_05 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_contribuicao_lead.mes_06 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_contribuicao_lead.mes_07 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_contribuicao_lead.mes_08 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_contribuicao_lead.mes_09 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_contribuicao_lead.mes_10 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_contribuicao_lead.mes_11 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_contribuicao_lead.mes_12 | percent: '1.0-0'}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.test_drive_realizado.descricao}}</td>
          <td class="text-right">{{dadosMensal.test_drive_realizado.mes_01}}</td>
          <td class="text-right">{{dadosMensal.test_drive_realizado.mes_02}}</td>
          <td class="text-right">{{dadosMensal.test_drive_realizado.mes_03}}</td>
          <td class="text-right">{{dadosMensal.test_drive_realizado.mes_04}}</td>
          <td class="text-right">{{dadosMensal.test_drive_realizado.mes_05}}</td>
          <td class="text-right">{{dadosMensal.test_drive_realizado.mes_06}}</td>
          <td class="text-right">{{dadosMensal.test_drive_realizado.mes_07}}</td>
          <td class="text-right">{{dadosMensal.test_drive_realizado.mes_08}}</td>
          <td class="text-right">{{dadosMensal.test_drive_realizado.mes_09}}</td>
          <td class="text-right">{{dadosMensal.test_drive_realizado.mes_10}}</td>
          <td class="text-right">{{dadosMensal.test_drive_realizado.mes_11}}</td>
          <td class="text-right">{{dadosMensal.test_drive_realizado.mes_12}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.conversao_testDrive_sr.descricao}}</td>
          <td class="text-right percentual">{{dadosMensal.conversao_testDrive_sr.mes_01 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.conversao_testDrive_sr.mes_02 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.conversao_testDrive_sr.mes_03 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.conversao_testDrive_sr.mes_04 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.conversao_testDrive_sr.mes_05 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.conversao_testDrive_sr.mes_06 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.conversao_testDrive_sr.mes_07 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.conversao_testDrive_sr.mes_08 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.conversao_testDrive_sr.mes_09 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.conversao_testDrive_sr.mes_10 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.conversao_testDrive_sr.mes_11 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.conversao_testDrive_sr.mes_12 | percent: '1.0-0'}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.percentual_trade_in.descricao}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_trade_in.mes_01 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_trade_in.mes_02 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_trade_in.mes_03 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_trade_in.mes_04 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_trade_in.mes_05 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_trade_in.mes_06 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_trade_in.mes_07 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_trade_in.mes_08 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_trade_in.mes_09 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_trade_in.mes_10 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_trade_in.mes_11 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_trade_in.mes_12 | percent: '1.0-0'}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.valor_medio_carro_usado.descricao}}</td>
          <td class="text-right">{{dadosMensal.valor_medio_carro_usado.mes_01 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medio_carro_usado.mes_02 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medio_carro_usado.mes_03 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medio_carro_usado.mes_04 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medio_carro_usado.mes_05 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medio_carro_usado.mes_06 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medio_carro_usado.mes_07 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medio_carro_usado.mes_08 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medio_carro_usado.mes_09 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medio_carro_usado.mes_10 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medio_carro_usado.mes_11 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medio_carro_usado.mes_12 | currency: 'BRL'}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.valor_medioNf_fabricaDealer.descricao}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_fabricaDealer.mes_01 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_fabricaDealer.mes_02 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_fabricaDealer.mes_03 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_fabricaDealer.mes_04 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_fabricaDealer.mes_05 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_fabricaDealer.mes_06 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_fabricaDealer.mes_07 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_fabricaDealer.mes_08 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_fabricaDealer.mes_09 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_fabricaDealer.mes_10 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_fabricaDealer.mes_11 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_fabricaDealer.mes_12 | currency: 'BRL'}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.valor_medioNf_DealerCliente.descricao}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_DealerCliente.mes_01 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_DealerCliente.mes_02 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_DealerCliente.mes_03 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_DealerCliente.mes_04 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_DealerCliente.mes_05 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_DealerCliente.mes_06 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_DealerCliente.mes_07 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_DealerCliente.mes_08 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_DealerCliente.mes_09 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_DealerCliente.mes_10 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_DealerCliente.mes_11 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.valor_medioNf_DealerCliente.mes_12 | currency: 'BRL'}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.margem_media_lucro.descricao}}</td>
          <td class="text-right">{{dadosMensal.margem_media_lucro.mes_01 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.margem_media_lucro.mes_02 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.margem_media_lucro.mes_03 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.margem_media_lucro.mes_04 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.margem_media_lucro.mes_05 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.margem_media_lucro.mes_06 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.margem_media_lucro.mes_07 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.margem_media_lucro.mes_08 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.margem_media_lucro.mes_09 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.margem_media_lucro.mes_10 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.margem_media_lucro.mes_11 | currency: 'BRL'}}</td>
          <td class="text-right">{{dadosMensal.margem_media_lucro.mes_12 | currency: 'BRL'}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.percentual_margem_media_lucro.descricao}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_margem_media_lucro.mes_01 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_margem_media_lucro.mes_02 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_margem_media_lucro.mes_03 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_margem_media_lucro.mes_04 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_margem_media_lucro.mes_05 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_margem_media_lucro.mes_06 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_margem_media_lucro.mes_07 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_margem_media_lucro.mes_08 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_margem_media_lucro.mes_09 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_margem_media_lucro.mes_10 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_margem_media_lucro.mes_11 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_margem_media_lucro.mes_12 | percent: '1.0-0'}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.qtd_carro_financiado.descricao}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado.mes_01}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado.mes_02}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado.mes_03}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado.mes_04}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado.mes_05}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado.mes_06}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado.mes_07}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado.mes_08}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado.mes_09}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado.mes_10}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado.mes_11}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado.mes_12}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.percentual_venda_financiada.descricao}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_financiada.mes_01 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_financiada.mes_02 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_financiada.mes_03 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_financiada.mes_04 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_financiada.mes_05 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_financiada.mes_06 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_financiada.mes_07 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_financiada.mes_08 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_financiada.mes_09 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_financiada.mes_10 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_financiada.mes_11 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_venda_financiada.mes_12 | percent: '1.0-0'}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.qtd_carro_financiado_banco.descricao}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado_banco.mes_01}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado_banco.mes_02}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado_banco.mes_03}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado_banco.mes_04}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado_banco.mes_05}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado_banco.mes_06}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado_banco.mes_07}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado_banco.mes_08}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado_banco.mes_09}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado_banco.mes_10}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado_banco.mes_11}}</td>
          <td class="text-right">{{dadosMensal.qtd_carro_financiado_banco.mes_12}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.percentual_penetracao_banco.descricao}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_penetracao_banco.mes_01 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_penetracao_banco.mes_02 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_penetracao_banco.mes_03 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_penetracao_banco.mes_04 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_penetracao_banco.mes_05 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_penetracao_banco.mes_06 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_penetracao_banco.mes_07 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_penetracao_banco.mes_08 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_penetracao_banco.mes_09 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_penetracao_banco.mes_10 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_penetracao_banco.mes_11 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_penetracao_banco.mes_12 | percent: '1.0-0'}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.percentual_medio_entrada.descricao}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_medio_entrada.mes_01 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_medio_entrada.mes_02 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_medio_entrada.mes_03 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_medio_entrada.mes_04 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_medio_entrada.mes_05 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_medio_entrada.mes_06 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_medio_entrada.mes_07 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_medio_entrada.mes_08 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_medio_entrada.mes_09 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_medio_entrada.mes_10 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_medio_entrada.mes_11 | percent: '1.0-0'}}</td>
          <td class="text-right percentual">{{dadosMensal.percentual_medio_entrada.mes_12 | percent: '1.0-0'}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.tempo_medio_estoque.descricao}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_estoque.mes_01}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_estoque.mes_02}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_estoque.mes_03}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_estoque.mes_04}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_estoque.mes_05}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_estoque.mes_06}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_estoque.mes_07}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_estoque.mes_08}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_estoque.mes_09}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_estoque.mes_10}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_estoque.mes_11}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_estoque.mes_12}}</td>
        </tr>
        <tr>
          <td>{{dadosMensal.tempo_medio_suprimento.descricao}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_suprimento.mes_01}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_suprimento.mes_02}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_suprimento.mes_03}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_suprimento.mes_04}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_suprimento.mes_05}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_suprimento.mes_06}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_suprimento.mes_07}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_suprimento.mes_08}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_suprimento.mes_09}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_suprimento.mes_10}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_suprimento.mes_11}}</td>
          <td class="text-right">{{dadosMensal.tempo_medio_suprimento.mes_12}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>